import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./MainDashboard/Header";
import { Outlet, useLocation } from "react-router-dom";
import { useGlobalContext } from "../GlobalContext";
import LogoutWatcher from "./Utils/LogoutWatcher";
import AccessDeniedPage from "./Utils/AccessDeniendPage";

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const {
    showOld,
    setShowOld,
    isAccessDenied,
    setIsAccessDenied,
    accessDeniedMessage,
    setAccessDeniedMessage,
  } = useGlobalContext();

  useEffect(() => {
    setIsAccessDenied(false);
    setAccessDeniedMessage("");
  }, [location.pathname, setIsAccessDenied, setAccessDeniedMessage]);

  const currentPath = location.pathname.toLowerCase();

  const isAdminAccessPage =
    currentPath === "/admin" ||
    currentPath.startsWith("/admin/") ||
    currentPath === "/admin-access" ||
    currentPath.startsWith("/admin-access/");

  return (
    <div className="flex h-dvh min-h-0 w-full overflow-hidden bg-slate-50">
      <LogoutWatcher type="admin" />

      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <div className="shrink-0">
          <Header showOld={showOld} setShowOld={setShowOld} />
        </div>

        {isAccessDenied ? (
          <main className="min-h-0 min-w-0 flex-1 overflow-y-auto bg-slate-50 p-2">
            <AccessDeniedPage
              message={accessDeniedMessage || "Access Denied"}
              subMessage="You do not have permission to access this section."
            />
          </main>
        ) : isAdminAccessPage ? (
          <main className="relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-slate-50 p-2">
            <div className="relative min-h-0 min-w-0 flex-1 overflow-hidden">
              <Outlet />
            </div>
          </main>
        ) : (
          <main className="min-h-0 min-w-0 flex-1 overflow-y-auto bg-slate-50 p-2">
            <Outlet />
          </main>
        )}
      </div>
    </div>
  );
}
